import { BaseModel } from "@/store/feathers/feathers.client.js";
import colors from 'quasar/src/utils/colors.js';
const { setBrand } = colors

export default class Merchants extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Merchants";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (process.env.NODE_ENV !== 'production') console.log("[MERCHANT SETUP]", data);

    store.state.ids.merchant_id = data.id
    store.state.ids.reseller_id = data.reseller_id
    store.state.ids.group_id = data.group_id
    store.state.ids.tenant_id = data.tenant_id
    store.state.ids.app_id = data.app_id
    store.state.ids.merchant_settings_id = data.settings_id

    if (data.default_address) {
      data.default_address = new models.api.Addresses(data.default_address);
    }

    if (data.billing_address) {
      data.billing_address = new models.api.Addresses(data.billing_address);
    }

    if (data.shipping_address) {
      data.shipping_address = new models.api.Addresses(data.shipping_address);
    }

    if (data.default_phone) {
      data.default_phone = new models.api.Phones(data.default_phone);
    }

    if (data.default_email) {
      data.default_email = new models.api.Emails(data.default_email);
    }

    if (data.tenant) data.tenant = new models.api.Tenants(data.tenant);
    
    if (data.settings) {
      data.settings = new models.api.MerchantSettings(data.settings);
    }

    if (data.theme) {
      data.theme = new models.api.Themes(data.theme);
      store.state.ids.theme_id = data.theme.id

      console.log("[MERCHANT THEME]", data.theme);

      if (!localStorage.getItem("dark_mode")) localStorage.setItem("dark_mode", 'false')
      if (data.theme.screen_mode === 'light') localStorage.setItem("dark_mode", 'false')
      if (data.theme.screen_mode === 'dark') localStorage.setItem("dark_mode", 'true')

      if (localStorage.getItem("dark_mode") === 'true') store.state.config.dark_mode = true
      else store.state.config.dark_mode = false

      if (store.state.config.dark_mode) {
        if (data.theme.dark_primary) setBrand('primary', data.theme.dark_primary)
        if (data.theme.dark_secondary) setBrand('secondary', data.theme.dark_secondary)
        if (data.theme.dark_accent) setBrand('accent', data.theme.dark_accent)
        if (data.theme.dark_positive) setBrand('positive', data.theme.dark_positive)
        if (data.theme.dark_negative) setBrand('negative', data.theme.dark_negative)
        if (data.theme.dark_info) setBrand('info', data.theme.dark_info)
        if (data.theme.dark_warning) setBrand('warning', data.theme.dark_warning)
      } else {
        if (data.theme.primary) setBrand('primary', data.theme.primary)
        if (data.theme.secondary) setBrand('secondary', data.theme.secondary)
        if (data.theme.accent) setBrand('accent', data.theme.accent)
        if (data.theme.positive) setBrand('positive', data.theme.positive)
        if (data.theme.negative) setBrand('negative', data.theme.negative)
        if (data.theme.info) setBrand('info', data.theme.info)
        if (data.theme.warning) setBrand('warning', data.theme.warning)
      }
    }

    if (data.mids) {
      data.mids.map(async (mid) => {
        mid = new models.api.Mids(mid);
      });
    }

    if (data.addresses) {
      data.addresses.map(async (address) => {
        address = new models.api.Addresses(address);
      });
    }

    if (data.phones) {
      data.phones.map(async (phone) => {
        phone = new models.api.Phones(phone);
      });
    }

    if (data.emails) {
      data.emails.map(async (email) => {
        email = new models.api.Emails(email);
      });
    }

    return data;
  }
}
